/* CarGauge product page (Task 06A + 06 Part 2A).
   1) Wishlist: keep aria-pressed on the product-page wishlist button in step with the
      "whislist-added" class that the existing theme.wishlist code toggles. Read-only: no click
      handlers, no storage access, no wishlist logic. (06A, unchanged)
   2) Description: the theme clamps the mobile description to 370px behind a Read More overlay even
      when the text already fits. Flag the wrapper when it fits so CSS can drop the clamp/overlay.
   3) Mobile sticky purchase bar: IntersectionObserver visibility + one-way state mirroring from the
      main product form. No scroll listener, no variant engine, no cart code: the tap is forwarded
      to the existing [data-add-to-cart] button. */
(function () {
  'use strict';

  /* ---------- 1. wishlist aria-pressed (06A) ---------- */
  var SEL = '.product_shop button[data-icon-wishlist]';

  function sync(btn) {
    var on = btn.classList.contains('whislist-added') ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== on) btn.setAttribute('aria-pressed', on);
  }

  function startWishlist() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) sync(list[i]);
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType === 1 && t.matches && t.matches(SEL)) sync(t);
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  /* ---------- 2. description fit guard ---------- */
  var CLAMP = 370; /* same value theme.js (_setShowmore_description) uses */

  function startDescriptionGuard() {
    var bars = document.querySelectorAll('.description_showmore');
    Array.prototype.forEach.call(bars, function (bar) {
      var wrap = bar.parentElement;
      var inner = wrap && wrap.firstElementChild;
      if (!wrap || !inner || inner === bar) return;

      /* Task 06 Part 3: Read More / Read Less are <span class="btn"> driven by theme.js click handlers.
         Give them button semantics + keyboard activation; theme.js still does the toggling. */
      var more = bar.querySelector('.showmore .btn');
      var less = bar.querySelector('.showless .btn');
      [[more, less, 'false'], [less, more, 'true']].forEach(function (pair) {
        var el = pair[0], other = pair[1];
        if (!el) return;
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-expanded', pair[2]);
        if (wrap.id) el.setAttribute('aria-controls', wrap.id);
        el.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          e.preventDefault();
          el.click();
          if (other) setTimeout(function () { other.focus(); }, 0);
        });
      });

      function measure() {
        /* a collapsed/hidden panel measures 0: keep the previous verdict instead of guessing */
        if (!wrap.offsetParent || !inner.offsetHeight) return;
        var fits = inner.offsetHeight <= CLAMP;
        if (wrap.classList.contains('cg-desc-fits') !== fits) wrap.classList.toggle('cg-desc-fits', fits);
      }

      measure();
      window.addEventListener('load', measure);
      if (window.ResizeObserver) new ResizeObserver(measure).observe(inner);
      else window.addEventListener('resize', measure);
    });
  }

  /* ---------- 3. mobile sticky purchase bar ---------- */
  function startSticky() {
    var bar = document.querySelector('[data-cg-sticky]');
    var main = document.querySelector('.product_shop [data-add-to-cart]');
    if (!bar || !main) return;

    var btn = bar.querySelector('[data-cg-sticky-atc]');
    var btnText = bar.querySelector('[data-cg-sticky-atc-text]');
    var priceOut = bar.querySelector('[data-cg-sticky-price]');
    var variantOut = bar.querySelector('[data-cg-sticky-variant]');
    var qtyOut = bar.querySelector('[data-cg-sticky-qty]');
    var priceSrc = document.querySelector('.product_shop [data-price]');
    var qtyIn = document.querySelector('.product_shop [data-quantity-input]');
    var form = main.closest('form');

    function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

    function variantLabel() {
      if (!form) return '';
      var parts = [];
      var groups = form.querySelectorAll('.selector-wrapper');
      Array.prototype.forEach.call(groups, function (g) {
        var picked = g.querySelector('input[type=radio]:checked');
        var select = g.querySelector('select');
        if (picked) parts.push(picked.value);
        else if (select && select.options[select.selectedIndex]) parts.push(select.options[select.selectedIndex].text);
      });
      return parts.join(' / ');
    }

    function mirror() {
      var sold = main.disabled || main.classList.contains('product-btn-soldOut') || main.getAttribute('aria-disabled') === 'true';
      var label = main.querySelector('[data-add-to-cart-text]');
      if (btnText && label) btnText.textContent = text(label);
      btn.disabled = sold;
      btn.classList.toggle('is-unavailable', sold);
      if (sold) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');

      if (priceOut && priceSrc) {
        var sale = priceSrc.querySelector('[data-sale-price]');
        var reg = priceSrc.querySelector('[data-regular-price]');
        var shown = sale && text(sale) ? text(sale) : (reg ? text(reg) : '');
        if (shown && priceOut.textContent !== shown) priceOut.textContent = shown;
      }
      if (variantOut) {
        var v = variantLabel();
        if (v && variantOut.textContent !== v) variantOut.textContent = v;
      }
      if (qtyOut && qtyIn) {
        var q = parseInt(qtyIn.value, 10);
        if (q > 1) { qtyOut.textContent = '\u00d7 ' + q; qtyOut.hidden = false; }
        else { qtyOut.textContent = ''; qtyOut.hidden = true; }
      }
    }

    /* forward the tap to the existing Add to Cart button (no cart logic here) */
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      main.click();
    });

    /* state mirroring: main button + price react to the theme's variant handling;
       qty comes from native events plus jQuery's trigger('change') used by theme.js */
    if (window.MutationObserver) {
      var mo = new MutationObserver(mirror);
      mo.observe(main, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], childList: true, characterData: true, subtree: true });
      if (priceSrc) mo.observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }
    if (qtyIn) {
      qtyIn.addEventListener('input', mirror);
      qtyIn.addEventListener('change', mirror);
      if (window.jQuery) window.jQuery(qtyIn).on('change.cgSticky', mirror);
    }
    if (form) form.addEventListener('change', mirror);
    mirror();

    /* visibility: shown only once the original purchase area has scrolled out above the viewport */
    if (!('IntersectionObserver' in window)) return;
    var target = main.closest('.button-group') || main;
    function update() {
      var r = target.getBoundingClientRect();
      var past = r.bottom <= 0;
      bar.classList.toggle('is-visible', past);
      document.documentElement.classList.toggle('cg-sticky-buy-on', past);
    }
    /* An observer only reports when a target crosses the viewport edge, so a jump straight past the
       CTA (scroll restoration, anchor link) would never fire for the CTA alone. The sibling theme
       sections are observed too: anything newly entering the viewport re-checks the CTA once.
       One rect read per observer callback, no scroll listener. */
    var io = new IntersectionObserver(update, { threshold: 0 });
    io.observe(target);
    var sec = main.closest('.shopify-section');
    if (sec && sec.parentElement) {
      Array.prototype.forEach.call(sec.parentElement.children, function (el) {
        if (el.nodeType === 1 && el !== sec) io.observe(el);
      });
    }
    window.addEventListener('pageshow', update);
    update();
  }

  /* ---------- 4. variant radios: Enter must not submit the product form (06B final validation) ----------
     Radios have no Enter action. Without this, Enter on a focused option radio triggers the browser's
     implicit form submission: a full-page POST to /cart/add that bypasses the ajax add-to-cart.
     One delegated keydown listener; arrow keys, Space and Tab are untouched (native radio behaviour). */
  function startRadioEnterGuard() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t && t.matches && t.matches('.product_shop .selector-wrapper input[type="radio"]')) e.preventDefault();
    });
  }


  /* ---------- 5. Task 28: option values, variant-driven badge/stock/Buy Now, Buy Now checkout ----------
     Read-only on the theme's variant engine: the selected variant is looked up in the product JSON the
     theme already prints (#ProductJson-<section id>). Buy Now posts the same form to /cart/add.js and then
     opens checkout. No storage, no cart rewrite. */
  function startPdp28() {
    var root = document.querySelector('.product_template');
    if (!root) return;
    var form = root.querySelector('.product_shop form[data-product-form]') || root.querySelector('.product_shop form');
    if (!form) return;
    var jsonEl = root.querySelector('script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }

    var buy = form.querySelector('[data-cg-buy-now]');
    var atc = form.querySelector('[data-add-to-cart]');
    var off = root.querySelector('[data-cg-off]');
    var stock = root.querySelector('[data-cg-stock]');
    var terms = form.querySelector('[data-cg-terms]');
    var priceSrc = root.querySelector('.product_shop [data-price]');

    function groups() {
      return Array.prototype.filter.call(form.querySelectorAll('.selector-wrapper'), function (g) {
        return g.querySelector('input[type=radio]') || g.querySelector('select');
      });
    }
    function picked(g) {
      var r = g.querySelector('input[type=radio]:checked');
      if (r) return r.value;
      var sel = g.querySelector('select');
      return sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].value : '';
    }

    /* "Color: Black": show the chosen value next to the option name */
    function syncOptionValues() {
      groups().forEach(function (g) {
        var label = g.querySelector('.form-label');
        if (!label || label.classList.contains('label--hidden')) return;
        var out = label.querySelector('.cg-opt-val');
        if (!out) {
          out = document.createElement('span');
          out.className = 'cg-opt-val';
          var em = label.querySelector('em');
          if (em) label.insertBefore(out, em); else label.appendChild(out);
        }
        var v = picked(g);
        var t = v ? ': ' + v : '';
        if (out.textContent !== t) out.textContent = t;
      });
    }

    function currentVariant() {
      if (!product || !product.variants || !product.variants.length) return null;
      if (product.variants.length === 1) return product.variants[0];
      var vals = groups().map(picked);
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = vals.length > 0;
        for (var j = 0; j < vals.length; j++) if (v.options[j] !== vals[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function syncVariant() {
      syncOptionValues();
      var v = currentVariant();
      if (v && off) {
        var c = Number(v.compare_at_price) || 0, p = Number(v.price) || 0;
        var pct = c > p ? Math.floor((c - p) * 100 / c) : 0;
        if (pct > 0) {
          var txt = (off.getAttribute('data-template') || '__%').replace('__', pct);
          if (off.textContent !== txt) off.textContent = txt;
          off.hidden = false;
        } else {
          off.hidden = true;
          off.textContent = '';
        }
      }
      if (v && stock) {
        stock.classList.toggle('is-in', !!v.available);
        stock.classList.toggle('is-out', !v.available);
        var st = stock.getAttribute(v.available ? 'data-in' : 'data-out');
        if (st && stock.textContent !== st) stock.textContent = st;
      }
      if (buy) {
        var sold = v ? !v.available : false;
        if (atc && (atc.disabled || atc.classList.contains('product-btn-soldOut'))) sold = true;
        buy.disabled = sold;
        if (sold) buy.setAttribute('aria-disabled', 'true'); else buy.removeAttribute('aria-disabled');
      }
    }

    /* Buy Now: add the selected variant, then go to checkout */
    function showError(msg) {
      var wrap = form.querySelector('[data-error-message-wrapper]');
      var out = form.querySelector('[data-error-message]');
      if (wrap && out) {
        out.textContent = msg;
        wrap.classList.remove('product-form__error-message-wrapper--hidden');
      }
    }
    if (buy) {
      buy.addEventListener('click', function () {
        if (buy.disabled || buy.classList.contains('is-busy')) return;
        if (terms && !terms.checked) {
          var box = terms.closest('.cg-pdp-terms');
          if (box) box.classList.add('is-invalid');
          terms.setAttribute('aria-invalid', 'true');
          terms.focus();
          return;
        }
        var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        buy.classList.add('is-busy');
        buy.setAttribute('aria-busy', 'true');
        fetch(r + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        }).then(function (out) {
          if (out.ok) { window.location.href = r + 'checkout'; return; }
          buy.classList.remove('is-busy');
          buy.removeAttribute('aria-busy');
          showError((out.data && (out.data.description || out.data.message)) || 'Could not add this item. Please try again.');
        }).catch(function () {
          buy.classList.remove('is-busy');
          buy.removeAttribute('aria-busy');
          showError('Could not add this item. Please try again.');
        });
      });
    }
    if (terms) terms.addEventListener('change', function () {
      var box = terms.closest('.cg-pdp-terms');
      if (box) box.classList.remove('is-invalid');
      terms.removeAttribute('aria-invalid');
    });

    form.addEventListener('change', syncVariant);
    if (window.MutationObserver) {
      var mo = new MutationObserver(syncVariant);
      if (priceSrc) mo.observe(priceSrc, { childList: true, characterData: true, subtree: true });
      if (atc) mo.observe(atc, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    }
    syncVariant();
  }

  function start() {
    startWishlist();
    startDescriptionGuard();
    startSticky();
    startRadioEnterGuard();
    startPdp28();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
